import { ID_PREFIX } from "./constants"

/**
 * Prepends a constant prefix to an ID
 *
 * @param {string} id ID of an element
 * @returns {string}
 */
export const getPrefixedId = (id) => (id ? `${ID_PREFIX}${id}` : "")

/**
 * Converts the first character of `string` to upper case and the remaining to lower case
 *
 * @param {string} word The string to capitalize
 * @returns {string} Returns the capitalized string
 */
export const capitalise = (word = "") =>
  word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase()

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @param  {...string} words Strings to convert
 * @returns {string} Returns the camel cased string.
 */
export const camelCase = (...words) => {
  return words.reduce((result, word, index) => {
    word = word.toLowerCase()
    return result + (index ? capitalise(word) : word)
  }, "")
}
